var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isSaving)?_c('div',{staticClass:"config-saving-indicator"},[_c('i',{staticClass:"fa-solid fa-circle-notch fa-spin"}),_vm._v(" "+_vm._s(_vm.__('settings_saving'))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }